import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
  
  render() {
    return(
      <div className="banner">
        <h1>
          Create your first project <br className="hide-mobile" /> to start adding apps <br/> <Link className="btn" to="/apps" >Go to dashboard</Link>
        </h1>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/CreateBanner.js